import { gql } from "urql"

import { AO_MIN_INGESTED_AT, goldsky } from "./graphql-client"
import { TransactionsResponse } from "../types"
import { messageFields, parseTokenEvent, TokenTransferMessage } from "../utils/arweave-utils"

const tokenTransfersQuery = (includeCount = false) => gql`
  query (
    $sender: String!
    $recipient: String!
    $limit: Int!
    $sortOrder: SortOrder!
    $cursor: String
  ) {
    transactions(
      sort: $sortOrder
      first: $limit
      after: $cursor

      tags: [
        { name: "Action", values: ["Credit-Notice", "Debit-Notice"] },
        { name: "Sender", values: [$recipient, $sender] },
      ]
      recipients: [$recipient, $sender]
      ${AO_MIN_INGESTED_AT}
    ) {
      ${includeCount ? "count" : ""}
      ...MessageFields
    }
  }

  ${messageFields}
`

export async function getTokenTransfers(
  sender: string,
  recipient: string,
  limit = 100,
  cursor = "",
  ascending: boolean,
): Promise<[number | undefined, TokenTransferMessage[]]> {
  try {
    const result = await goldsky
      .query<TransactionsResponse>(tokenTransfersQuery(!cursor), {
        limit,
        sortOrder: ascending ? "HEIGHT_ASC" : "INGESTED_AT_DESC",
        cursor,
        //
        sender,
        recipient,
      })
      .toPromise()
    const { data } = result

    if (!data) return [0, []]

    const { count, edges } = data.transactions
    const events = edges.map(parseTokenEvent)

    return [count, events]
  } catch (error) {
    return [0, []]
  }
}
